import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IAppInstall {
    date?: number
    total?: number
    created_at?: number
}
export const getAppInstall = async (limit: number): Promise<ApiRes<IAppInstall[]>> => {
    return await apiGet(API_URL, `admin/app_install/graph?limit=${limit}`)
}
